import clsx from 'clsx'
import React, { ChangeEvent } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

type Props = {
  name: string
  options: Array<{ id: string; label: string }>
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void

  field?: UseFormRegisterReturn<string>
  touched?: boolean
  error?: boolean
  disabled?: boolean
  autoComplete?: string
  emptyLabel?: string
  classes?: string
  value?: string
}

export default function DropdownSelect({
  name,
  options,
  onChange,
  field,
  touched,
  error,
  disabled,
  autoComplete,
  emptyLabel,
  classes,
  value,
}: Props) {
  return (
    <select
      {...field}
      onChange={onChange}
      id={name}
      name={name}
      className={clsx(
        'mt-2 block h-10 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6',
        classes,
        touched && error ? 'ring-red-600' : 'ring-gray-300',
        disabled ? 'bg-slate-300' : '',
      )}
      autoComplete={autoComplete}
      disabled={disabled}
      {...(value ? { value } : {})}
    >
      {emptyLabel && <option className="hidden" value="" label={emptyLabel} />}
      {options.map(({ id, label }) => (
        <option key={`${name}-${id}`} value={id}>
          {label}
        </option>
      ))}
    </select>
  )
}
